export const FETCH_LOAD_ALL_THERMITY_PROJECT_REQUEST = 'FETCH_LOAD_ALL_THERMITY_PROJECT_REQUEST'
export const FETCH_LOAD_ALL_THERMITY_PROJECT_SUCCESS = 'FETCH_LOAD_ALL_THERMITY_PROJECT_SUCCESS'
export const FETCH_LOAD_ALL_THERMITY_PROJECT_FALUIRE = 'FETCH_LOAD_ALL_THERMITY_PROJECT_FALUIRE'

